module.exports = __webpack_public_path__ + "img/secret_one.0575916e.png";